import { MeetingPrepCardReveal as MeetingPrepCardRevealNode } from "@acto/gql/graphql";

export default class MeetingPrepCardReveal {
  constructor(
    public readonly id: string,
    public readonly clientId: string,
    public readonly prepSessionId: string,
    public readonly cardKey: string,
  ) {}

  static fromGraphql(
    data: Pick<MeetingPrepCardRevealNode, "id" | "clientId" | "prepSessionId" | "cardKey">,
  ): MeetingPrepCardReveal {
    return new MeetingPrepCardReveal(data.id, data.clientId, data.prepSessionId, data.cardKey);
  }
}
